/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
} from './Direction';
import type { LookupMappings } from './LookupMappings';
import {
    LookupMappingsFromJSON,
    LookupMappingsFromJSONTyped,
    LookupMappingsToJSON,
} from './LookupMappings';
import type { PromptGroups } from './PromptGroups';
import {
    PromptGroupsFromJSON,
    PromptGroupsFromJSONTyped,
    PromptGroupsToJSON,
} from './PromptGroups';

/**
 * A revision of a prompt for contact summarisation
 * @export
 * @interface PromptRevision
 */
export interface PromptRevision {
    /**
     * Fixed Prompt Hash Key
     * @type {string}
     * @memberof PromptRevision
     */
    promptHashKey: string;
    /**
     * Name of the prompt revision
     * @type {string}
     * @memberof PromptRevision
     */
    name: string;
    /**
     * 
     * @type {PromptGroups}
     * @memberof PromptRevision
     */
    promptGroups: PromptGroups;
    /**
     * 
     * @type {LookupMappings}
     * @memberof PromptRevision
     */
    queueIds?: LookupMappings;
    /**
     * 
     * @type {Direction}
     * @memberof PromptRevision
     */
    initialDirection?: Direction;
    /**
     * 
     * @type {number}
     * @memberof PromptRevision
     */
    duration?: number;
    /**
     * The time at which the resource was created
     * @type {number}
     * @memberof PromptRevision
     */
    createdAt: number;
    /**
     * The time of the most recent update
     * @type {number}
     * @memberof PromptRevision
     */
    updatedAt: number;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof PromptRevision
     */
    createdBy: CallingIdentity;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof PromptRevision
     */
    updatedBy: CallingIdentity;
    /**
     * Identifier for the prompt revision
     * @type {string}
     * @memberof PromptRevision
     */
    promptRevisionId: string;
    /**
     * Original prompt ID used when setting the ID as the published prompt
     * @type {string}
     * @memberof PromptRevision
     */
    originalPromptRevisionId?: string;
}


/**
 * Check if a given object implements the PromptRevision interface.
 */
export function instanceOfPromptRevision(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "promptHashKey" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "promptGroups" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "createdBy" in value;
    isInstance = isInstance && "updatedBy" in value;
    isInstance = isInstance && "promptRevisionId" in value;

    return isInstance;
}

export function PromptRevisionFromJSON(json: any): PromptRevision {
    return PromptRevisionFromJSONTyped(json, false);
}

export function PromptRevisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromptRevision {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'promptHashKey': json['promptHashKey'],
        'name': json['name'],
        'promptGroups': PromptGroupsFromJSON(json['promptGroups']),
        'queueIds': !exists(json, 'queueIds') ? undefined : LookupMappingsFromJSON(json['queueIds']),
        'initialDirection': !exists(json, 'initialDirection') ? undefined : DirectionFromJSON(json['initialDirection']),
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'createdBy': CallingIdentityFromJSON(json['createdBy']),
        'updatedBy': CallingIdentityFromJSON(json['updatedBy']),
        'promptRevisionId': json['promptRevisionId'],
        'originalPromptRevisionId': !exists(json, 'originalPromptRevisionId') ? undefined : json['originalPromptRevisionId'],
    };
}

export function PromptRevisionToJSON(value?: PromptRevision | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'promptHashKey': value.promptHashKey,
        'name': value.name,
        'promptGroups': PromptGroupsToJSON(value.promptGroups),
        'queueIds': LookupMappingsToJSON(value.queueIds),
        'initialDirection': DirectionToJSON(value.initialDirection),
        'duration': value.duration,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'createdBy': CallingIdentityToJSON(value.createdBy),
        'updatedBy': CallingIdentityToJSON(value.updatedBy),
        'promptRevisionId': value.promptRevisionId,
        'originalPromptRevisionId': value.originalPromptRevisionId,
    };
}

